export enum EGeoActions {
  REMEMBER_LOCATION = 'geo/remember_location',

  GET_LOCATIONS_REQUEST_START = 'geo/get_locations_request_start',
  GET_LOCATIONS_REQUEST_ERROR = 'geo/get_locations_request_error',
  GET_LOCATIONS_REQUEST_SUCCESS = 'geo/get_locations_request_success',
}
